
export interface Ism {
    enabled: boolean;
    region: Region;
    mode: Mode;
    seek: boolean;
    lorawan: Lorawan | undefined;
    star: Star | undefined;
}

export interface Lorawan {
    public: boolean;
    auth: Auth;
    appeui: string;
    appkey: string;
    bandmask: string;
    adr: boolean;
    dr: number;
    txp: number;
    serverId?: string;
}

export interface Star {
    gateway: boolean
    channel: number
}

export enum Region {
    AS923 = "AS923",
    AU915 = "AU915",
    // CN470 = "CN470",
    // CN779 = "CN779",
    // EU433 = "EU433",
    EU868 = "EU868",
    IN865 = "IN865",
    KR920 = "KR920",
    US915 = "US915",
    // RU864 = "RU864"
}

export enum Mode {
    Star = "star",
    LoRaWAN = "lorawan",
    // MESH = "mesh"
}

export enum Auth {
    OTAA = "otaa"
}

type RegionsMap = {
    [key in Region]: {
        DR: {min: number, max: number};
        TXP: {maxPwr: number, minPwr: number}; // a lower TXP has a higher power (0 is maximum power)
    };
};

// The map encapsulating DR and TXP data for each region
export const RegionsData: RegionsMap = {
    [Region.AS923]: { DR: { min: 0, max: 7 }, TXP: { maxPwr: 0, minPwr: 7 } },
    [Region.AU915]: { DR: { min: 0, max: 13 }, TXP: { maxPwr: 0, minPwr: 14 } },
    // [Region.CN470]: { DR: { min: 1, max: 5 }, TXP: { maxPwr: 0, minPwr: 7 } },
    // // CN779 - not supposed to be used after 2021 for new? (https://resources.lora-alliance.org/technical-specifications/rp002-1-0-4-regional-parameters)
    // [Region.CN779]: { DR: { min: 0, max: 7 }, TXP: { maxPwr: 0, minPwr: 5 } },
    // [Region.EU433]: { DR: { min: 0, max: 7 }, TXP: { maxPwr: 0, minPwr: 5 } },
    [Region.EU868]: { DR: { min: 0, max: 7 }, TXP: { maxPwr: 0, minPwr: 7 } },
    [Region.IN865]: { DR: { min: 0, max: 7 }, TXP: { maxPwr: 0, minPwr: 10 } },
    [Region.KR920]: { DR: { min: 0, max: 5 }, TXP: { maxPwr: 0, minPwr: 7 } },
    // [Region.RU864]: { DR: { min: 0, max: 7 }, TXP: { maxPwr: 0, minPwr: 7 } },
    [Region.US915]: { DR: { min: 0, max: 4 }, TXP: { maxPwr: 0, minPwr: 14 } },
};
